import request from '@/utils/request'
let baseURL = '/pay-api';

//查询平台金币详情
export function platformCoin() {
  return request({
    url: '/integral/v1/getIntegralOfPlatform',
    method: 'get',
    baseURL,
  })
}


// 获取用户的个人代币钱包，有则返回，无则生成------------------------- 此接口抛弃，换为getAntIntegralWallet
// export function myCoin(userOpenId, productCode) {
//   return request({
//     url: `/integral/v1/getWalletByProductCode/${userOpenId}/${productCode}`,
//     method: 'get',
//     baseURL,
//   })
// }
/*
* userOpenId: 用户openId
* productCode: 代币编码(AntCoin)
* */


// 代币钱包详情(区分个人钱包和店铺钱包)
export function getAntIntegralWallet(data) {
  return request({
    url: '/integral/v1/getAntIntegralWallet',
    method: 'post',
    baseURL,
    data
  })
}
/*
{userOpenid: userOpenId, code: productCode,walletType:0}

{
code (string): 代币编码(金币：AntCoin) ,
userOpenid (string): 用户openid，包括普通用户openid及店铺shopid ,
walletType (integer): 钱包类型，0：个人钱包，1：店铺钱包 +++++++++++
}
* */







// 查询用户代币记录（分页） （查询用户积分记录）
export function antCoinRecord(data) {
  return request({
    url: '/integral/v1/getAntIntegralRecordByUserId',
    method: 'post',
    baseURL,
    data,
  })
}
/*
 {
openId (string): 用户openId ,
page (integer, optional): 页码 ,
productCode (string): 代币编码（金币：AntCoin） ,
size (integer, optional): 每页大小 ,
type (integer): 交易类型，0：全部 1：充值 2：转帐 3：奖励 4：红包 ,
walletType (integer, optional): 钱包类型，0：个人钱包，1：店铺钱包 ++++++++++++++
}
* */


//代币个人对个人转帐（金币转移）
export function integralTransfer(data) {
  return request({
    url: '/integral/v1/integralTransfer',
    method: 'post',
    baseURL,
    data,
  })
}
/*
{
amount (string): 转移数量 ,
fromUserOpenId (string): 转出用户openId ,
fromWalletType (integer): 转出钱包类型，0：个人钱包，1：店铺钱包 +++++++++++++++++
payPassword (string): 交易密码 ,
productCode (string): 代币编码（金币：AntCoin） ,
remarks (string, optional): 备注信息 ,
toUserOpenId (string): 转入用户openId ,
toWalletType (integer): 转入钱包类型，0：个人钱包，1：店铺钱包 ++++++++++++++++++
}
* */


// 购买金币 (生成订单)
export function integralRecharge(data) {
  return request({
    url: '/recharge/v1/integralRecharge',
    method: 'post',
    baseURL,
    data,
  })
}
/*
{
amount (string): 购买数量 ,
ip (string, optional): 客户端IP ,
money (string): 支付金额 ,
payPassword (string): 交易密码 ,
payType (string): 付款方式(aliPay:支付宝, wxPay:微信, wxH5Pay:微信H5, wxJSAPI:微信JS支付 blcPay:现金余额，antPay:金币余额) ,
userOpenId (string): 用户openId ,
walletAccount (string): 钱包帐号 ,
wapName (string, optional): WAP 网站名 ,
wapType (string, optional): 微信H5场景类型 ,
wapUrl (string, optional): WAP网站URL地址
}
* */
